import { Helmet } from 'react-helmet-async';
import { useParams } from 'src/routes/hooks';
import AddCandidatesView from 'src/sections/job-candidate/view/add-candidates';

export default function AddJobCandidatePage() {
  const { id: jobId } = useParams();

  return (
    <>
      <Helmet>
        <title> HireIntel.AI - Add Candidate </title>
      </Helmet>

      <AddCandidatesView jobId={jobId} />
    </>
  );
}
